// extracted by mini-css-extract-plugin
export default {"trigger":"Menu_trigger__0v5Kv","popper":"Menu_popper__UokNT"};